<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__rdaccount}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.advertiserId" placeholder="广告主账号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('demo:rdaccount:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('demo:rdaccount:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
<!--        </el-form-item>-->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="advertPlatform" label="所属广告平台" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="advertiserId" label="广告主账号" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="advertiserName" label="广告主名称" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="email" label="联系邮箱" header-align="center" align="center"></el-table-column>
        <el-table-column prop="balance" label="账户总余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="validBalance" label="账户可用总余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cash" label="现金余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="validCash" label="账户总余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="grantss" label="赠款余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="defaultGrant" label="默认广告位可用赠款余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="commonGrant" label="通用广告位可用赠款余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="searchGrant" label="搜索广告位可用赠款余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="unionGrant" label="穿山甲广告位可用赠款余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="validGrant" label="赠款可用余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="returnGoodsAbs" label="返货余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="validReturnGoodsAbs" label="返货可用余额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="returnGoodsCost" label="返货支出(元)" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="status" label="状态（开1、关0）" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="createdBy" label="创建人" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="updatedBy" label="修改人" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="updateTime" label="修改时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="deleteTime" label="删除时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button v-if="$hasPermission('demo:rdaccount:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
<!--            <el-button v-if="$hasPermission('demo:rdaccount:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './rdaccount-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/rdaccount/page',
        getDataListIsPage: true,
        exportURL: '/sys/rdaccount/export',
        deleteURL: '/sys/rdaccount',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        advertiserId:''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
